module.exports = __webpack_public_path__ + "static/media/LK__Completed.4cfa141e.svg";